import styled from 'styled-components';

export const SnowSkiMapContainer = styled.div`
    height: 350px;
    width: 99%;
    margin-left: 4px;
    display: flex;
`;